import React from 'react';
import { Col, Row } from 'reactstrap';
import UserForm from './UserForm';
import Section from '../../../components/common/Section';
import Logo from '../../../components/navbar/Logo';
import AuthWizardProvider from './AuthWizardProvider';
import bg1 from '../../../assets/img/generic/condominium.jpg';
import { Link } from 'react-router-dom';

const WizardLayout = () =>
  <Section className="py-0" image={bg1} position="center bottom" overlay>
    <Row className="flex-center min-vh-100 py-6">
      <Col sm={10} lg={7} className="col-xxl-5">
        <Logo bordered />
        <AuthWizardProvider>
          <UserForm />
        </AuthWizardProvider>
      </Col>
    </Row>
  </Section>

export default WizardLayout;